export default {
    configuration: true,
    'searchList': {
        'searchTxt': [{
            'name': '叉车序号',
            'value': 'serialNum',
            'type': 'input',
            'unfold': true,
            'span': 3,
            'multiple': false
        },
        {
            'name': '叉车编码',
            'value': 'forkliftCode',
            'type': 'input',
            'unfold': true,
            'span': 3,
            'multiple': false
        },
        {
            'name': '叉车状态',
            'value': 'enableFlag',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'options': [
                {
                    label: '启用',
                    value: '0'
                },
                {
                    label: '停用',
                    value: '1'
                }
            ]
        },
        {
            'name': '设备类型',
            'value': 'deviceType',
            'type': 'select',
            'unfold': true,
            'optionNum': 'SRM_DEVICE_TYPE_NAME',
            'span': 3,
            'multiple': false
        },
        {
            'name': '设备品牌',
            'value': 'deviceBrand',
            'type': 'select',
            'unfold': true,
            'optionNum': 'SRM_EQUIPMENT_BRAND',
            'span': 3,
            'multiple': false
        },
        {
            'name': '是否新车',
            'value': 'newFlag',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'options': [
                {
                    label: '是',
                    value: '0'
                },
                {
                    label: '否',
                    value: '1'
                }
            ]
        }],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table': {
        'switchType': true,
        'tableCut': false,
        'clickState': false,
        'selectBtn': true,
        'height': 300,
        'columns': [
            {
                'label': '叉车序号',
                'prop': 'serialNum',
                'width': '220px'
            },
            {
                'label': '叉车编码',
                'prop': 'forkliftCode',
                'width': '120px'
            },
            {
                'label': '出厂时间',
                'prop': 'deliveryDate',
                'width': '160px'
            },
            {
                'label': '设备类型',
                'prop': 'deviceType',
                'width': '180px'
            },
            {
                'label': '设备品牌',
                'prop': 'deviceBrand',
                'width': '100px'
            },
            {
                'label': '型号',
                'prop': 'model',
                'width': '120px'
            },
            {
                'label': '核载重量',
                'prop': 'payload',
                'width': '120px'
            },
            {
                'label': '是否新车',
                'prop': 'newFlag',
                'width': '120px'
            },
            {
                'label': '叉车状态',
                'prop': 'enableFlag',
                'width': '120px'
            },
            {
                'label': '供应商编码',
                'prop': 'supplierCode',
                'width': '180px'
            }],
        'action': [],
        'leftWidth': 100
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};